import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    '& ::before': {
      borderBottom: 'none',
      transition: 'none',
    },

    '& ::after': {
      borderBottom: 'none',
      transition: 'none',
    },
    '& input': {
      background: 'rgba(64,64,64,0.2)',
      borderRadius: '2px',
      padding: '8px',
      border: '1px solid rgba(255,255,255,0.2)',
    },
  },
});


const InCardTextFieldWrapper = (props) => {
  const { classes, children } = props;
  return (
    <div className={classes.root}>
      {children}
    </div>
  );
};

InCardTextFieldWrapper.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(InCardTextFieldWrapper);
